import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {PreviousDocument, TransitDeclaration, TransitGoodsItem} from '@portbase/bezoekschip-service-typescriptmodels';
import {removeItem} from '../../../common/utils';
import {AppContext} from "../../../app-context";

@Component({
    selector: 'app-transit-goods',
    templateUrl: './transit-goods.component.html',
    styleUrls: ['./transit-goods.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransitGoodsComponent {
  appContext = AppContext;
  @Input() declaration: TransitDeclaration;
  @Input() isTemplate: boolean = false;

  removeItem(item: TransitGoodsItem) {
    return () => {
      this.declaration.data.houseConsignments.map(houseConsignment => houseConsignment.goodsItems)
        .concat([this.declaration.data.goodsItems]).forEach(goodsItems => {
        if (goodsItems.some(goodsItem => goodsItem === item)) {
          removeItem(goodsItems, item);
        }
      });
    }
  }

  emptyGoodsItem() {
    return <TransitGoodsItem>{previousDocument: <PreviousDocument>{}};
  };

  isEditable = (): boolean => {
    const status = this.declaration?.status;

    if (!status || status.cancellation || status.cancellationRequest || status.release ||
      (status.sent && (status.accept || !status.reject))) {
      return false;
    } else {
      return this.appContext.isTransitEditor();
    }
  };
}
